module.exports = __webpack_public_path__ + "static/media/logooo.77f5c095.png";